import React from 'react';
import styled from '@emotion/styled';
import { Button, Typography } from 'antd';
import { appStyles } from '../../../../styles';
import { Align } from '../../../../types/common';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  description?: string;
  title?: string;
  ctaText?: string;
  colorOpacity?: string;
  heading?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isToUpperCase?: boolean;
  isPreview?: boolean;
  height?: string;
  className?: string;
}

const toButtonAlign = (buttonAlign: Align) => {
  if (buttonAlign === Align.LEFT) {
    return 'flex-start';
  }
  if (buttonAlign === Align.RIGHT) {
    return 'flex-end';
  }
  if (buttonAlign === Align.CENTER) {
    return 'center';
  }
  return 'flex-start';
};

const { Text } = Typography;

export const JustInPreview = (props: PreviewProps) => {
  const { values, isToUpperCase, isPreview, height, className } = props;
  const { backgroundImage, textColor, description, title, ctaText, colorOpacity, heading, buttonAlign, textAlign } =
    values;
  const color = textColor || '#8C8B8F';
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;
  return (
    <StyledPromotionPreview
      className={`Preview ${isDefaultImage ? 'default-image' : ''} ${className}`}
      style={{ height: height || '300px' }}
    >
      {heading && <Text className="heading">{heading}</Text>}

      <div className="preview-just-in">
        {!isDefaultImage ? (
          <img src={backgroundImage} alt="" />
        ) : (
          <StyledLinearGradient
            style={{
              background: `linear-gradient(180deg, transparent, rgba(0, 0, 0, ${
                isNaN(Number(colorOpacity)) ? 0 : Number(colorOpacity)
              })), 50%`,
            }}
          />
        )}
        <>
          <div className="wrapper-text-preview promotion-preview" style={{ textAlign }}>
            <>
              <Text className="title" style={{ color }}>
                {title && isToUpperCase ? title.toUpperCase() : title}
              </Text>
              <br />
              <Text className="description" style={{ color }}>
                {description && isToUpperCase ? description.toUpperCase() : description}
              </Text>
            </>
            {ctaText && (
              <div className="wrapper-btn-preview" style={{ justifyContent: toButtonAlign(buttonAlign) }}>
                <Button className="button">{ctaText}</Button>
              </div>
            )}
          </div>
        </>
      </div>
    </StyledPromotionPreview>
  );
};

const StyledLinearGradient = styled.div`
  width: 150px;
  ${appStyles.borderRadiusPreview}
`;

const StyledPromotionPreview = styled.div`
  ${appStyles.borderRadiusPreview}
  margin: 2rem;
  min-height: 130px;
  position: relative;
  text-align: left;
  font-family: 'DIN Condensed Bold';
  line-height: 1.2;
  & .heading {
    position: absolute;
    top: -24px;
    left: 0;
    width: 300px;
    font-size: 18px;
  }
  & .preview-just-in {
    ${appStyles.fullWidthHeight}
    margin: 0;
    position: absolute;
    display: flex;
    left: 0;
    flex-direction: row;
    img {
      width: 110px;
      border-radius: 0.75rem 0 0 0.75rem;
      padding: 0;
      border: 1px solid transparent;
    }
  }
  .wrapper-text-preview {
    width: 100%;
    padding: 0.5rem 1rem;
    border-radius: 0 0 0.75rem;
    position: relative;
    ${appStyles.background.white}
  }
  & .title {
    font-size: 25px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      margin-top: 10px;
      font-size: 26px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding-right: 2rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 12px;
      }
    }
  }
`;
